export default __webpack_public_path__ + "static/media/frame-market-hero.e8e66e74.png";